import PropTypes from "prop-types"

/**
 * PropTypes for a single mapped OCPI tariff price component.
 *
 * @property {string} type - Component type (ENERGY, FLAT, PARKING_TIME, TIME)
 * @property {number} price - Unit price (origin cost, as received from the network)
 * @property {number} [finalPrice] - Margin-applied driver-facing price for this component
 * @property {number|null} vat - VAT percentage, when set
 * @property {number} stepSize - Billing step size
 */
export const tariffPriceComponentPropTypes = {
	type: PropTypes.string,
	price: PropTypes.number,
	finalPrice: PropTypes.number,
	vat: PropTypes.number,
	stepSize: PropTypes.number,
}

/**
 * PropTypes for TariffRestrictions component.
 *
 * @property {Object|null} restrictions - Raw OCPI restrictions object for a tariff element
 */
export const tariffRestrictionsPropTypes = {
	restrictions: PropTypes.object,
}

/**
 * PropTypes for TariffElement component.
 *
 * @property {Object} element - Mapped tariff element
 * @property {Array<Object>} [element.priceComponents] - Price components for this element
 * @property {Object} [element.restrictions] - Duration/time-window restrictions for this element
 * @property {string} currency - Tariff currency, used to format price components
 */
export const tariffElementPropTypes = {
	element: PropTypes.shape({
		priceComponents: PropTypes.arrayOf(PropTypes.shape(tariffPriceComponentPropTypes)),
		restrictions: PropTypes.object,
	}).isRequired,
	currency: PropTypes.string,
}

/**
 * PropTypes for the OCPI tariffs SidebarSection component.
 *
 * @property {Object|null} selectedTariff - Currently selected tariff object (null if no selection)
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Number of tariffs matching the current server-side filters
 * @property {Object|null} marginRule - The operator's currently active margin rule, or null when none applies
 */
export const ocpiTariffsSidebarSectionPropTypes = {
	selectedTariff: PropTypes.object,
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	visibleCount: PropTypes.number.isRequired,
	marginRule: PropTypes.object,
}

/**
 * PropTypes for OcpiTariffs view.
 * No external props are expected; kept for consistency across view definitions.
 */
export const ocpiTariffsViewPropTypes = {}
